import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  dashedBorder: {
    border: "1px dashed",
    borderColor: theme.palette.primary.main,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  text: {
    marginBottom: theme.spacing(2),
  },
  movieDetailContainer: {
    marginTop: theme.spacing(2),
    marginLeft: "6%",
    marginRight: "6%",
    paddingBottom: theme.spacing(4),
  },
  movieDescriptionContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  playerContainer: {
    marginTop: theme.spacing(1),
    width: "100%",
    backgroundColor: "black",
  },
  player: {
    margin: "auto",
    maxWidth: 1120,
  },
}));
